import React, { Component, Fragment } from 'react';
export default class AmazonLink extends Component {
  render() {
    return (
      <Fragment>
        <a
          target="_blank"
          href={
            'https://www.amazon.com/gp/product/' +
            this.props.product +
            '/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=' +
            this.props.product +
            '&linkCode=as2&tag=propertyhints-20&linkId=' +
            this.props.link_id
          }
        >
          <img
            border="0"
            style={{ width: '100%' }}
            src={
              '//ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&MarketPlace=US&ASIN=' +
              this.props.product +
              '&ServiceVersion=20070822&ID=AsinImage&WS=1&Format=_SL250_&tag=propertyhints-20'
            }
          />
        </a>
        <img
          src={'//ir-na.amazon-adsystem.com/e/ir?t=propertyhints-20&l=am2&o=1&a=' + this.props.product}
          height="1"
          border="0"
          alt=""
          style={{ border: 'none', margin: '0px', width: '100%', maxWidth: '600px' }}
        />
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/AmazonLink.jsx